// import {
//     FETCH_STATIONS,
//     CHANGE_CHECKED_STATION,
//     SET_STATION_DETAILS,
//     CLEAR_REGISTERS,
//     CHANGE_STATION_FIELD,
//     HANDLE_POPUP,
//     SET_UPDATED_STATION
// } from '../../actions/stations';

import {GET_STATIONS_ADMIN, CLEAN_BATCH} from "../../actions/stations";
import {SUBSCRIPTION_STATIONS, SUBSCRIPTION_DATA} from "../../actions/webSocket";

// let stationFields = () => {
//     return {
//         station_id: '',
//         currentNode: {
//             node_id: '',
//             from: new Date()
//         },
//         status: 'idle'
//     }
// };

export const stationStatus = ['active', 'idle', 'disabled'];

const initialState = {
    stations: [],
    count: 0,
    batch: []
};

const stations = (state = initialState, action) => {

    // let aux;

    switch (action.type) {
        case GET_STATIONS_ADMIN:
            return {
                ...state,
                stations: action.stationList,
                count: action.stationList.length
            };

        case SUBSCRIPTION_STATIONS:
            return {
                ...state,
                stations: action.stations,
                count: action.stations.length
            };

        case SUBSCRIPTION_DATA:
            return {
                ...state,
                batch: action.data
            };

        case CLEAN_BATCH:
            return {
                ...state,
                batch: action.batch
            };

        // case FETCH_STATIONS:
        //     action.stations.forEach((x) => {
        //         x.checked = false;
        //     });
        //
        //     return {
        //         ...state,
        //         stations: action.stations,
        //         count: action.stations.length
        //     };
        // case HANDLE_POPUP:
        //
        //     let popUpInfo = {};
        //     popUpInfo.popUp = action.state;
        //     popUpInfo.msg = action.msg;
        //
        //     return {
        //         ...state,
        //         stationForm: popUpInfo
        //     };
        //
        // case SET_UPDATED_STATION:
        //     aux = state.stations;
        //
        //     let newStations = aux.map(station => {
        //         if (station.id === action.attrs.station_id) {
        //             Object.keys(action.attrs).forEach( key=>{
        //                 console.log(station[key])
        //                 if (key !== 'station_id')
        //                     station[key].value = action.attrs[key]
        //                 console.log( action.attrs[key])
        //             })
        //         }
        //         console.log('ret')
        //         return station
        //     });
        //
        //     console.log(newStations)
        //     return {
        //         ...state,
        //         stations: newStations
        //     };
        // case CLEAR_REGISTERS:
        //
        //     return {
        //         ...state,
        //         currentStation: stationFields()
        //     };
        //
        // case CHANGE_CHECKED_STATION:
        //     state.stations[action.index].checked = !state.stations[action.index].checked;
        //     return {
        //         ...state,
        //         stations: state.stations
        //     };
        //
        // case CHANGE_STATION_FIELD:
        //     aux = state.currentStation;
        //     if (action.field === 'from' || action.field === 'node_id')
        //         aux.currentNode[action.field] = action.value;
        //     else
        //         aux[action.field] = action.value;
        //
        //     console.log(aux)
        //
        //     return {
        //         ...state,
        //         currentStation: aux
        //     };
        //
        // case SET_STATION_DETAILS:
        //     let stationDetails = stationFields();
        //     stationDetails.station_id = action.station.id;
        //     stationDetails.currentNode = action.station.currentNode.value;
        //     stationDetails.status = action.station.status.value;
        //     stationDetails.historyNodes = action.station.historyNodes.value;
        //     return {
        //         ...state,
        //         currentStation: stationDetails
        //     };
        default:
            return state

    }
};

export default stations



// WEBPACK FOOTER //
// ./src/reducers/stations/stations.js